import React, { useState } from "react";
import styled from "styled-components/macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUp,
  faArrowDown,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import ElectricHall from "../CarpenterView/ElectricHall";

const UpperShelf = styled.div`
  border: solid 1px #020202;
  background-color: rgba(0, 0, 0, 0);
  height: 9px;
`;

const UnitBoxDraw = ({
  popupItem,
  isBottom,
  isTop,
  isFirst,
  item,
  colorUnit,
  onRemovePress,
  onUpPress,
  onDownPress,
  isCarpenter,
  isSticker,
  isWires,
  count,
  isElectric,
}) => {
  const {
    title,
    color,
    cellSize,
    size,
    frameColor = "#FFFFFF",
    showDoor = true,
    security_door,
  } = item;

  const [onHover] = useState(false);
  const electricDict = {
    standard: "2",
    "2 standard": "3",
    "vacuum cleaner": "4",
    printer: "5",
    fridge: "6",
    freezer: "6",
  };

  return (
    <BoxWrapper>
      <Box>
        {isTop && <UpperShelf />}
        {
          <Box style={{ flexDirection: "column" }}>
            <Wrapper
              isSticker={isSticker}
              bgColor={
                (!showDoor && isCarpenter && !isSticker) || isWires
                  ? "#c1ac8f"
                  : isSticker
                  ? color
                  : "none"
              }
              frameColor={colorUnit || frameColor}
              size={size}
              isTop={isTop}
              isFirst={isFirst}
            >
              {isElectric && (
                <ElectricHall electricStandard={item.electric_standart} />
              )}
              {isCarpenter &&
                !isSticker &&
                !isWires &&
                (showDoor ? (
                  <div>
                    <br/>
                    <p style={{ textAlign:"center" }}>
                      Door size:{cellSize} <br />
                      {security_door && <p>*Extra security</p>}
                    </p>
                  </div>
                ) : (
                  <p>
                    No Door <br /> No Lock
                  </p>
                ))}

              {(isSticker || isWires) && (
                <div style={{ textAlign: "center" }}>
                  {isSticker && <InnerText fontSize={18}>{title} </InnerText>}
                  <br />
                  {!isElectric && (
                    <InnerText fontSize={22}> {count - 1}</InnerText>
                  )}
                </div>
              )}
              {isElectric && (
                <InnerText fontSize={26}>
                  {electricDict[item.electric_standart]}
                </InnerText>
              )}
            </Wrapper>
            <DividerHorizontal />
            {showDoor && !isSticker && !isWires && <Rect />}
            {!isElectric && isWires && (
              <div>
                <WireRect />
                {isTop && !isFirst && <VerticalWire top={-23} height={23} />}
                {isTop && isFirst && <VerticalWire top={-415} height={415} />}
                {!isBottom && <FullVerticalWire />}
              </div>
            )}
          </Box>
        }
      </Box>

      {onRemovePress && !popupItem && onHover && (
        <FontAwesomeIcon
          onClick={onRemovePress}
          style={{
            filter: "drop-shadow(0px 0px 1px black)",
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: 9999999999,
            padding: "10px",
          }}
          size={"3x"}
          color={"white"}
          icon={faTimesCircle}
        />
      )}

      {onUpPress && !popupItem && !isTop && onHover && (
        <FontAwesomeIcon
          onClick={onUpPress}
          style={{
            filter: "drop-shadow(0px 0px 1px black)",
            position: "absolute",
            top: -2,
            right: 0,
            left: 0,
            padding: "3px",
            margin: "auto",
            zIndex: 9999999999,
          }}
          size={"2x"}
          color={"white"}
          icon={faArrowUp}
        />
      )}
      {onDownPress && !popupItem && !isBottom && onHover && (
        <FontAwesomeIcon
          onClick={onDownPress}
          style={{
            filter: "drop-shadow(0px 0px 1px black)",
            position: "absolute",
            bottom: 6,
            right: 0,
            left: 0,
            padding: "3px",
            margin: "auto",
            zIndex: 9999999999,
          }}
          size={"2x"}
          color={"white"}
          icon={faArrowDown}
        />
      )}
    </BoxWrapper>
  );
};

const Box = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
`;

const Wrapper = styled.div`
  border: 1px solid black;
  z-index: 3;
  width: 180px; //166px;
  padding: ${(isSticker) => (isSticker ? 20 : 0)}px;
  height: ${({ size, isTop, isFirst }) =>
    isTop && !isFirst ? size + 17 : size + 8}px;
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  border-radius: 2px;
  background-color: ${(props) => props.bgColor};
`;

const DividerHorizontal = styled.div`
  width: 180px;
  height: 10px;
  border: 1px solid black;
  //align-self: center;
`;
const InnerText = styled.span`
  text-align: center;
  font-size: ${(props) => props.fontSize}px;
`;
const Rect = styled.div`
  position: absolute;
  top: 0;
  border: 1px solid black;
  left: 0;
  border-bottom-right-radius: 10px;
  width: 42px;
  height: 25px;
  z-index: 99999999999999;
`;

const WireRect = styled.div`
  position: absolute;
  top: 0;
  border: 1px solid black;
  left: 0;
  background-color: black;
  width: 42px;
  height: 10px;
  z-index: 999999999999;
`;
const VerticalWire = styled.div`
  position: absolute;
  top: ${(props) => props.top}px;
  left: 10px;
  width: 1px;
  height: ${(props) => props.height}px;
  z-index: 99999999;
  border-right: 2px solid red;
`;

const FullVerticalWire = styled.div`
  position: absolute;
  top: 0;
  left: 10px;
  width: 1px;
  height: 100%;
  z-index: 99999999;
  border-right: 2px solid red;
`;
const BoxWrapper = styled.div`
  display: flex;
  position: relative;
`;

export { UnitBoxDraw };
